import FlexBox from "components/FlexBox/FlexBox";
import systemAIIcon from "assets/images/system-ai.svg";
import { Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { css } from "@emotion/react";
import { Trans, useTranslation } from "react-i18next";

const IntelligenceTooltipContent: React.FC<{ onClose: () => void; onLearnMore?: () => void }> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <TooltipContent data-testid={"IntelligenceTooltipContent"}>
      <FlexBox spacing={3} flexDirection={"row"}>
        <StyledImage src={systemAIIcon} alt={"OI Icon"} />
        <StyledDescription>
          <StyledTypography variant="body2">
            <Trans
              i18nKey={
                "OI created the <strong>Owners Group</strong> from the list of Registered Owners in the proof of ownership document."
              }
              defaults={
                "OI created the <strong>Owners Group</strong> from the list of Registered Owners in the proof of ownership document."
              }
              components={{
                strong: <strong />,
              }}
            />
          </StyledTypography>
          <StyledTypography variant="body2">
            {t("The system recognised you as one of the Registered Owners.")}
          </StyledTypography>
        </StyledDescription>
      </FlexBox>
      <TooltipActions>
        <Button data-testid={"CloseButton"} variant="contained" onClick={onClose}>
          Close
        </Button>
      </TooltipActions>
    </TooltipContent>
  );
};

const TooltipContent = styled("div")(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 308px;

    ${theme.mixins.flexGap("16px")}
  `
);

const TooltipActions = styled("div")(
  ({ theme }) => css`
    display: flex;
    justify-content: flex-end;
  `
);

const StyledDescription = styled("div")(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    ${theme.mixins.flexGap("16px")}
  `
);

const StyledImage = styled("img")(
  ({ theme }) => css`
    width: 26px;
    height: 26px;
  `
);

const StyledTypography = styled(Typography)(
  ({ theme }) => css`
    text-align: left;
    color: ${theme.palette.text.secondary};
  `
);

export default IntelligenceTooltipContent;
